var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.667,
    height: 8.667,
    viewBox: "718 712.167 8.667 8.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-plus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M722.333 712.167v8.667",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#df1681",
    fill: "transparent",
    "data-name": "Path 63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718 716.5h8.667",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#df1681",
    fill: "transparent",
    "data-name": "Path 64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkPlus);
export default __webpack_public_path__ + "static/media/pinkPlus.bac7194f6e2c68e3ac29c97ac8d90889.svg";
export { ForwardRef as ReactComponent };